import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Alert } from '@mui/material';
import { EmailEventInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  eventToUpdate: EmailEventInterface | null;
  setEventToUpdate: React.Dispatch<React.SetStateAction<EmailEventInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const EmailEventsUpdateDialog: React.FC<Props> = ({
  open,
  eventToUpdate,
  setEventToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update Email Event</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="Event Name"
        value={eventToUpdate?.eventName ?? ''}
        onChange={e => setEventToUpdate(ev => ev ? { ...ev, eventName: e.target.value } : ev)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Subject"
        value={eventToUpdate?.subject ?? ''}
        onChange={e => setEventToUpdate(ev => ev ? { ...ev, subject: e.target.value } : ev)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Template Name"
        value={eventToUpdate?.templateName ?? ''}
        onChange={e => setEventToUpdate(ev => ev ? { ...ev, templateName: e.target.value } : ev)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Description"
        value={eventToUpdate?.description ?? ''}
        onChange={e => setEventToUpdate(ev => ev ? { ...ev, description: e.target.value } : ev)}
        fullWidth
        margin="dense"
        multiline
        rows={3}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);
